import { HtmlControl } from './../../../models/html-control.model';
import { FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {

  public Control: HtmlControl;
  public Group: FormGroup;

  constructor() { }

  ngOnInit(): void {
    console.log('name', this.Control);
  }

}
